import React from 'react';
import { Button, Result } from 'antd';
import { Link } from 'react-router-dom';
import { LockOutlined } from '@ant-design/icons';

const UnauthorizedPage: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-200px)]">
      <Result
        status="warning"
        title="Access Denied"
        subTitle="Sorry, you don't have permission to access this page."
        icon={<LockOutlined style={{ fontSize: 64, color: '#f5222d' }} />}
        extra={
          <Link to="/home/news-info">
            <Button size={'small'} type="primary">
              Return to Home
            </Button>
          </Link>
        }
      />
    </div>
  );
};

export default UnauthorizedPage;
